var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lm-size-col-preview"},[_c('div',{staticClass:"lm-size-col-preview-offset",style:({width: _vm.offsetWidth})}),_c('div',{staticClass:"lm-size-col-preview-width",style:({width: _vm.width})})])}
var staticRenderFns = []

export { render, staticRenderFns }